import styled from "styled-components";
import { Link } from "react-router-dom";
import { primaryColor, primaryColorHover } from "../../../../config/constants";

export const FooterContainer = styled.footer`
  width: 100%;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  box-shadow: 0 -5px 15px rgba(0, 0, 0, 0.15);
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
`;
export const SubmitDiv = styled.div`
  width: 100%;
  max-width: 860px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  @media (max-width: 910px) {
    width: 85%;
  }
  @media (max-width: 400px) {
    margin: 0;
  }
`;
export const ContinueButton = styled.button`
  margin-right: 10px;
  padding: 10px;
  width: 108px;
  border: none;
  border-radius: 5px;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  background-color: ${primaryColor};
  outline: none;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  &:hover {
    background-color: ${primaryColorHover};
  }
`;
export const CancelButton = styled(Link)`
  padding: 10px;
  width: 108px;
  border: 1px solid ${primaryColor};
  border-radius: 5px;
  color: ${primaryColor};
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  background: transparent;
  outline: none;
  text-decoration: none;
  cursor: pointer;
`;
export const BackButton = styled.button`
  padding: 10px;
  width: 108px;
  border: 1px solid ${primaryColor};
  border-radius: 5px;
  color: ${primaryColor};
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  background: transparent;
  outline: none;
  cursor: pointer;
`;